import React, { useEffect, useRef, useState } from "react";
import { getdownload, getmetadata, send_metadata } from "../../api/api";
import { useNavigate, useParams } from "react-router-dom";
import LoadingScreen from "react-loading-screen";
import { toast } from "react-toastify";
import Modal from "../../components/Modal";

const data = {
  Certifications: [
    {
      Conformance: [
        "1.1 - WCAG 2.2",
        "1.1 - WCAG 2.2 Level AA",
        "1.1 - WCAG 22 Level A",
      ],
    },
    { Certified: ["Transforma Pvt Ltd", "Benetech"] },
    // {
    //   Credential:
    //     "#certifier'>https://bornaccessible.org/certification/gca-credential/</meta>",
    // },
  ],
  crediential: "https://bornaccessible.org/certification/gca-credential/",
};

const Metadata = ({ fileId, renderpage, setCompleted }) => {
  const [metaColumns, setMetaColumns] = useState([]);
  const [metaValues, setMetaValues] = useState([]);
  const [schema, setSchema] = useState([]);
  const [complexity, setComplexity] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [textareaValue, setTextareaValue] = useState("");
  const [formErrors, setFormErrors] = useState({
    schema: false, // Add a schema error state
  });
  const navigate = useNavigate();
  const [userdata, setUserData] = useState({
    schema_columns: "",
    meta_values: {},
    complexity: {},
    certification: {},
  });
  const [dropdownOpen, setDropdownOpen] = useState({});
  // const [selectedOptions, setSelectedOptions] = useState([]);
  const [authorOpen, setAuthorOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // const [runInBackground, setRunInBackground] = useState(false);
  const [stage, setStage] = useState();
  const authorref = useRef();
  const schemaref = useRef();

  const { category } = useParams();

  // useEffect(() => {
  //   setUserData({
  //     schema_columns: {
  //       "Access Mode": "textual,visual",
  //       "Sufficient Access Modes": "textual visual",
  //       "Accessibility Features":
  //         "pageBreakMarkers,pageNavigation,readingOrder,structuralNavigation,tableOfContents",
  //       "Accessibility Hazards": "none",
  //     },
  //   });
  // }, []);

  useEffect(() => {
    fetchdata(fileId);
  }, [fileId]);

  const fetchdata = async (currentFileId) => {
    try {
      let data = await getmetadata(currentFileId, category);
      if (data.data) {
        setMetaValues(data.data.meta_values);
        setMetaColumns(data.data.meta_columns);
        setSchema(data.data.schema_columns || []);
        setComplexity(data.data.complexity_columns);
        setStage({
          previous: data.data.previous_process,
          next: data.data.next_process,
        });
        const updatedMetaValues = {};
        data.data.meta_values.forEach((items) => {
          const key = Object.keys(items)[0];
          const updatedkey = `${key}`;
          updatedMetaValues[updatedkey] = items[key];
        });

        setUserData((prev) => ({
          ...prev,
          meta_values: updatedMetaValues,
        }));
      } else {
        // alert(data.error);
        toast.error(data.error.message);
      }
    } catch (e) {
      // alert(e);
      toast.error(e);
    }
  };

  useEffect(() => {
    const autoClose = (event) => {
      if (
        authorref.current &&
        !authorref.current.contains(event.target) &&
        !event.target.closest(".authordropdown")
      ) {
        setAuthorOpen(false);
      } else if (
        schemaref.current &&
        !schemaref.current.contains(event.target) &&
        !event.target.closest(".schemadropdown")
      ) {
        setDropdownOpen(false);
      }
    };

    window.addEventListener("mousedown", autoClose);

    return () => {
      window.removeEventListener("mousedown", autoClose);
    };
  });

  useEffect(() => {
    if (userdata && userdata.meta_values) {
      const metavalues = { ...userdata.meta_values }; // Create a copy to avoid direct mutation
      const key = Object.keys(metavalues)[1]; // Get the second key (if exists)

      // Ensure the value is not already an array
      if (key && typeof metavalues[key] === "string") {
        const toArray = metavalues[key].split(",");
        metavalues[key] = toArray; // Convert to an array

        // Update only if the value is different
        setUserData((prev) => ({
          ...prev,
          meta_values: metavalues,
        }));
      }
    }
  }, [userdata]);

  useEffect(() => {
    // Set default value in textarea and userData on initial render
    if (complexity.length > 0) {
      const defaultKey = Object.keys(complexity[0])[0];
      const defaultValue = complexity[0][defaultKey];
      setTextareaValue(defaultValue);
      setUserData((prev) => ({
        ...prev,
        complexity: { [`${defaultKey}`]: defaultValue },
      }));
    }
  }, [complexity]);

  const handlemetavalues = (e, i) => {
    const userInput = e.target.value;

    setMetaValues((prev) => {
      const updated = { ...prev };
      const key = Object.keys(updated[i]);

      updated[i] = { [key]: userInput };
      return updated;
    });

    setUserData((prev) => {
      const alldata = { ...userdata.meta_values };
      const key = Object.keys(alldata)[i];
      alldata[key] = userInput; // This will include the quotes in the key
      return {
        ...prev,
        meta_values: alldata,
      };
    });
  };

  // const handleSelect = (e, i) => {
  //   let userInput = e.target.value;

  //   let key = schema[i].name;

  //   setUserData((prev) => ({
  //     ...prev,
  //     schema_columns: {
  //       ...prev.schema_columns,
  //       [`${key}`]: userInput,
  //     },
  //   }));
  // };

  const handleSelect = (name, i) => {
    const userInput = name;
    console.log(userInput);

    const key = schema[i]?.name;

    setUserData((prev) => {
      const existingSelections = prev.schema_columns?.[key] || "";

      const selectionsArray = existingSelections
        .split(",")
        .filter((val) => val);

      let updatedSelections;

      if (selectionsArray.includes(userInput)) {
        updatedSelections = selectionsArray.filter((val) => val !== userInput);
      } else {
        updatedSelections = [...selectionsArray, userInput];
      }

      return {
        ...prev,
        schema_columns: {
          ...prev.schema_columns,
          [key]: updatedSelections.join(","),
        },
      };
    });
  };

  const handleRadioChange = (index) => {
    setSelectedIndex(index);
    const key = Object.keys(complexity[index])[0];
    const value = complexity[index][key];
    setTextareaValue(value); // Update textarea
    setUserData((prev) => ({
      ...prev,
      complexity: { [`${key}`]: value }, // Update userData
    }));
  };

  const handleTextareaChange = (e) => {
    const updatedValue = e.target.value;
    setTextareaValue(updatedValue); // Update textarea
    const key = Object.keys(complexity[selectedIndex])[0];
    setUserData((prev) => ({
      ...prev,
      complexity: { [`${key}`]: updatedValue }, // Update userData
    }));
  };

  useEffect(() => {
    const defaultCertifications = {};
    data.Certifications.forEach((item) => {
      const key = Object.keys(item)[0]; // e.g., "Conformance", "Certified"
      const value = item[key][0]; // Default to the first option
      defaultCertifications[key.toLowerCase()] = value;
    });

    defaultCertifications[`credentials`] =
      "https://bornaccessible.org/certification/gca-credential/";

    setUserData((prev) => ({
      ...prev,
      certification: defaultCertifications,
    }));
  }, []);

  const handleCertification = (e, title) => {
    const userInput = e.target.value;
    // console.log(title, userInput);

    setUserData((prev) => ({
      ...prev,
      certification: {
        ...prev.certification, // Preserve existing certifications
        [title]: userInput, // Update the specific certification
      },
    }));
  };

  const handleCredentialsChange = (e) => {
    const userInput = e.target.value;
    // console.log(userdata);
    setUserData((prev) => ({
      ...prev,
      certification: {
        ...prev,
        credientials: userInput,
      },
    }));
  };

  const senddata = async (event) => {
    event.preventDefault();
    const button = event.currentTarget;
    if (validateForm()) {
      setShowModal(true); // Show the modal
    } else {
      toast.warn("Please fill in all the fields");
    }
    button.disabled = false;
  };

  // console.log(runInBackground);

  // useEffect(() => {
  //   if (runInBackground) {
  //     confirmSentData();
  //   }
  // }, [runInBackground]);

  const runInBg = async () => {
    setShowModal(false);
    try {
      // console.log("run in background");
      setTimeout(() => {
        navigate("/accessibility_epub/dashboard");
      }, 2000); // Delay for 3 seconds
      let response = await send_metadata(fileId, userdata, category);
      if (response.data) {
        setCompleted(true);
        // handleDownload(fileId);
      } else {
        toast.error(response.error.message);
      }
    } catch (e) {
      toast.error(e);
    }
  };

  const runInloading = async () => {
    // console.log("run in loading");
    setLoading(true);
    try {
      let response = await send_metadata(fileId, userdata, category);
      if (response.data) {
        handleDownload(fileId);
        setLoading(false);
        navigate("/accessibility_epub/dashboard");
      } else {
        toast.error(response.error.message);
        setLoading(false);
      }
    } catch (e) {
      toast.error(e);
    }
  };

  // const confirmSentData = async () => {
  //   setShowModal(false); // Close the modal
  //   try {
  //     if (runInBackground) {
  //       console.log("run in background");

  //       let response = await send_metadata(fileId, userdata, category);
  //       if (response.data) {
  //         handleDownload(fileId);
  //       } else {
  //         toast.error(response.error.message);
  //       }
  //       navigate("/accessibility_epub/dashboard"); // Navigate immediately
  //     } else {
  //       // Run the process with loading screen
  //       console.log("run in loading");
  //       setLoading(true);
  //       const button = document.querySelector("button"); // Adjust selector as needed
  //       button.disabled = true;

  //       let response = await send_metadata(fileId, userdata, category);
  //       if (response.data) {
  //         setLoading(false);
  //         handleDownload(fileId);
  //         navigate("/accessibility_epub/dashboard");
  //       } else {
  //         toast.error(response.error.message);
  //         setLoading(false);
  //         button.disabled = false;
  //       }
  //     }
  //   } catch (e) {
  //     toast.error(e.message);
  //   }
  // };

  const handleNext = (e, fileId, nextpage) => {
    e.preventDefault();
    renderpage(fileId, nextpage);
  };

  // MARK: Validate form section
  const validateForm = () => {
    const errors = {
      schema: Object.values(userdata.schema_columns).some(
        (item) => !Object.values(schema).includes(item)
      ),
    };

    console.log(errors);

    setFormErrors(errors);
    // console.log(formErrors);
    return Object.values(errors).includes(true);
  };

  const toggleDropdown = (index) => {
    setDropdownOpen((prev) => ({
      [index]: !prev[index], // Toggle the specific dropdown
    }));
  };

  const handleauthorchange = (e, i) => {
    // Check if the user pressed the "Enter" key (key code 13)

    if (e.key === "Enter") {
      e.preventDefault();
      const userInput = e.target.value.trim(); // Get the input value and remove extra spaces

      if (userInput) {
        setMetaValues((prev) => {
          const updated = { ...prev };

          // Get the current value for the specific index and append the new input
          const currentValue = Object.values(updated[i])[0] || "";
          updated[i] = {
            [Object.keys(updated[i])[0]]: currentValue
              ? `${currentValue},${userInput}` // Append the new author name with a comma
              : userInput, // Set the author name if no existing value
          };
          toast.success("author added successfully");
          return updated;
        });

        setUserData((prev) => {
          const alldata = { ...userdata.meta_values };
          const key = Object.keys(alldata)[i];
          const currentValue = alldata[key] || [];
          const updatedValue = currentValue.toString().includes(",")
            ? [...currentValue.toString().split(","), userInput]
            : [...currentValue, userInput]; // If currentValue is a string, convert to array and append

          alldata[key] = updatedValue;
          return {
            ...prev,
            meta_values: alldata,
          };
        });

        // Clear the input field after adding the author
        e.target.value = "";
      }
    }
  };

  const handleauthordelete = (i, authorindex, items) => {
    const usermetavaluesKey = Object.keys(userdata.meta_values)?.[1]; // Get the key at index 1

    setUserData((prev) => {
      // Create a copy of the current meta_values object
      const updatedMetaValues = { ...prev.meta_values };

      if (usermetavaluesKey) {
        const authors = updatedMetaValues[usermetavaluesKey];

        if (Array.isArray(authors)) {
          updatedMetaValues[usermetavaluesKey] = authors.filter(
            (_, index) => index !== authorindex
          );
        }
        toast.success("author deleted successfully");
      }

      return {
        ...prev,
        meta_values: updatedMetaValues,
      };
    });
  };

  const downloadreport = (data, filename) => {
    try {
      const file = data;
      const byteCharacters = atob(file);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
        const slice = byteCharacters.slice(offset, offset + 1024);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      // console.log(byteArrays);
      const blob = new Blob(byteArrays, { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      downloadfile(url, filename);
    } catch (e) {
      // console.log(e);
      toast.error(e);
    }
  };

  const handleDownload = async (fileid) => {
    try {
      let data = await getdownload(fileid);
      if (data.data) {
        // console.log(data.data);
        downloadreport(data.data.content, data.data.file_name);
      }
    } catch (e) {
      // alert(e);
      toast.error(e);
    }
  };

  const downloadfile = (url, filename) => {
    if (url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = `${filename}`; // You can specify the name of the file here
      link.click();
      // Clean up the URL object
      window.URL.revokeObjectURL(url);
    } else {
      // alert("No File to Download");
      toast.info("No file to Download");
    }
  };

  // const handleConfirm = () => {
  //   setLoading(false);
  //   navigate("/accessibility/accessibility_epub/dashboard");
  // };

  console.log(userdata);

  return (
    <LoadingScreen
      loading={loading}
      bgColor="#f1f1f1"
      spinnerColor="#1A53A9"
      textColor="#1A53A9"
      text="Processing file please wait ...."
    >
      <div className="flex flex-col w-full bg-commonfill p-8">
        <form onSubmit={(e) => senddata(e)} className="flex flex-col gap-8">
          <div className="w-full flex flex-col gap-6 p-6 bg-white rounded-[16px] shadow-commonshadow">
            <div className="w-full text-left text-24 font-semibold">
              <h>Metadata Information</h>
            </div>
            {userdata.meta_values ? (
              <div className="grid lg:grid-cols-3 gap-4">
                {metaColumns.map((item, i) => (
                  <div className="flex flex-col text-left gap-3">
                    <label className="text-16 font-semibold">
                      {Object.values(item)}
                    </label>
                    {i === 1 ? (
                      <div className="flex flex-col gap-1 relative">
                        <div className="absolute -top-9 right-0 w-48 bg-white border-[1px] border-commonborder rounded-[8px] px-3 py-1 h-fit">
                          <div
                            onClick={() => setAuthorOpen(!authorOpen)}
                            className="flex justify-between authordropdown"
                          >
                            <p>Added Author </p>
                            <span className="ml-2 mt-1 cursor-pointer">
                              {!authorOpen ? (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M5.293 9.293a1 1 0 011.414 0L10 12.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              ) : (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="h-4 w-4"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M14.707 10.707a1 1 0 01-1.414 0L10 7.414l-3.293 3.293a1 1 0 11-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              )}
                            </span>
                          </div>
                          {authorOpen && (
                            <div
                              ref={authorref}
                              className="absolute top-10 bg-white border-[1px] border-commonborder rounded-[8px] w-full left-0 px-3 py-1"
                            >
                              {Object.values(userdata?.meta_values)?.[i]
                                ?.length > 0
                                ? Object.values(userdata?.meta_values)?.[
                                    i
                                  ]?.map((items, authorindex) => (
                                    <div className="flex justify-between w-full">
                                      <div title={items}>
                                        {items.length > 30
                                          ? items.slice(0, 30) + "..."
                                          : items}
                                      </div>
                                      <div
                                        onClick={() =>
                                          handleauthordelete(
                                            i,
                                            authorindex,
                                            items
                                          )
                                        }
                                        className="text-title cursor-pointer font-semibold"
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="currentColor"
                                          class="icon icon-tabler icons-tabler-filled icon-tabler-circle-x"
                                        >
                                          <path
                                            stroke="none"
                                            d="M0 0h24v24H0z"
                                            fill="none"
                                          />
                                          <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-6.489 5.8a1 1 0 0 0 -1.218 1.567l1.292 1.293l-1.292 1.293l-.083 .094a1 1 0 0 0 1.497 1.32l1.293 -1.292l1.293 1.292l.094 .083a1 1 0 0 0 1.32 -1.497l-1.292 -1.293l1.292 -1.293l.083 -.094a1 1 0 0 0 -1.497 -1.32l-1.293 1.292l-1.293 -1.292l-.094 -.083z" />
                                        </svg>
                                      </div>
                                    </div>
                                  ))
                                : "No author to show"}
                            </div>
                          )}
                        </div>
                        <div
                          key={i}
                          className="border-[1px] border-commonborder rounded-[12px] px-3 py-3 pt-3 h-fit"
                        >
                          <input
                            className="w-full outline-none"
                            type="text"
                            placeholder={`${Object.values(
                              item
                            )} - Type and Press Enter to add`}
                            onKeyDown={(e) => handleauthorchange(e, i)}
                            name=""
                            title={
                              userdata &&
                              Object.values(userdata?.meta_values)[1]?.[i]
                                ?.length > 10
                                ? Object.values(metaValues[i])
                                : ""
                            }
                          />
                        </div>
                      </div>
                    ) : (
                      <div
                        key={i}
                        className="border-[1px] border-commonborder rounded-[12px] px-3 py-3"
                      >
                        <input
                          className="w-full outline-none"
                          type="text"
                          placeholder={Object.values(item)}
                          onChange={(e) => handlemetavalues(e, i)}
                          value={
                            Object.values(metaValues[i]) !== null
                              ? Object.values(metaValues[i])
                              : ""
                          }
                          name=""
                          title={
                            Object.values(metaValues[i])[0] !== null
                              ? Object.values(metaValues[i])[0].length > 10
                                ? Object.values(metaValues[i])
                                : ""
                              : ""
                          }
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              <div className="flex h-full w-full justify-center items-center">
                Loading metavalues please wait...
              </div>
            )}
          </div>
          {/* MARK: Scheme option section */}
          <div className="flex flex-col md:flex-row gap-8">
            <div className="w-full md:w-1/2 p-6 text-left bg-white rounded-[16px] shadow-commonshadow">
              <div className="w-full text-left text-24 font-semibold">
                <h>Schema</h>
              </div>
              {schema.length > 0 ? (
                <div className="flex flex-col mt-6 gap-4">
                  {schema.map((item, i) => (
                    <div key={i} className="flex flex-col gap-3 relative">
                      <p className="text-18 text-dimtext">{item.name}</p>
                      {/* <select
                    onChange={(e) => handleSelect(e, i)}
                    className="rounded-[8px] outline-none px-4 py-3 w-full appearance-none border-[1px] border-commonborder"
                    required
                  >
                    <option>Choose an Option</option>
                    {item.schema_drop.map((option, i) => (
                      <option key={i} required>
                        {option.name}
                      </option>
                    ))}
                  </select> */}
                      <div className="relative">
                        {/* Dropdown Button */}
                        <div
                          className="schemadropdown bg-white border border-gray-300 rounded-lg px-4 py-2 w-full text-left flex justify-between items-center"
                          onClick={() => toggleDropdown(i)} // Toggle dropdown for the specific index
                        >
                          <p className="w-full overflow-hidden">
                            {userdata.schema_columns?.[item.name]
                              ? userdata.schema_columns?.[item.name]
                              : "Choose an Option"}
                          </p>
                          <span className="ml-2">
                            {!dropdownOpen[i] ? (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M5.293 9.293a1 1 0 011.414 0L10 12.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            ) : (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="h-4 w-4"
                                viewBox="0 0 20 20"
                                fill="currentColor"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M14.707 10.707a1 1 0 01-1.414 0L10 7.414l-3.293 3.293a1 1 0 11-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z"
                                  clipRule="evenodd"
                                />
                              </svg>
                            )}
                          </span>
                        </div>

                        {/* Dropdown Menu */}
                        {dropdownOpen[i] && (
                          <ul
                            ref={schemaref}
                            className="absolute z-10 bg-white border border-gray-300 rounded-lg w-full mt-2 shadow-lg max-h-[300px] overflow-auto"
                          >
                            {item.schema_drop.map((option, index) => (
                              <li
                                key={index}
                                className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${
                                  userdata.schema_columns?.[item.name]
                                    ?.split(",")
                                    .map((val) => val.trim().toLowerCase())
                                    .includes(option.name.trim().toLowerCase())
                                    ? "bg-blue-100"
                                    : ""
                                }`}
                                onClick={(e) => handleSelect(option.name, i)}
                              >
                                {console.log(
                                  userdata.schema_columns[item.name]
                                )}
                                {option.name}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>

                      {/* <svg
                    class="absolute top-[70%] right-8 transform -translate-y-1/2 w-4 h-4 text-gray-500 pointer-events-none"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M19 9l-7 7-7-7"
                    ></path>
                  </svg> */}
                    </div>
                  ))}
                  <div className="w-full text-left text-red-500">
                    {formErrors.schema === true ? (
                      <p>Please select all schema options.</p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ) : (
                <div className="flex h-full w-full justify-center items-center">
                  "Loading Schema Option please wait ..."
                </div>
              )}
            </div>
            <div className="w-full md:w-1/2 p-6 text-left bg-white rounded-[16px] shadow-commonshadow">
              <div className="w-full text-left text-24 font-semibold">
                <h>Complexity</h>
              </div>
              <div className="w-full flex flex-wrap mt-6 gap-8">
                {complexity.map((item, i) => (
                  <div key={i} className="flex gap-3">
                    <input
                      className="h-5 w-5"
                      type="radio"
                      name="select"
                      checked={i === selectedIndex}
                      onChange={() => handleRadioChange(i)}
                    />
                    <p className="text-18">{Object.keys(item)}</p>
                  </div>
                ))}
              </div>
              <div className="flex flex-col mt-8 gap-4">
                <p className="text-18 text-dimtext">Summary</p>
                <textarea
                  value={textareaValue}
                  onChange={handleTextareaChange}
                  className="w-full min-h-[300px] max-h-[350px] overflow-auto border-[1px] border-commonborder rounded-[12px] p-4 outline-none"
                ></textarea>
              </div>
            </div>
          </div>
          <div className="w-full p-6 bg-white rounded-[16px] shadow-commonshadow">
            <div className="w-full text-left text-24 font-semibold">
              <h>Certifications</h>
            </div>
            <div className="flex flex-col gap-6 mt-8">
              {data.Certifications.map((items, i) => (
                <div key={i} className="flex gap-6 ">
                  {Object.keys(items).map((it, i) => (
                    <div
                      key={i}
                      className="flex w-full text-left flex-col md:flex-row"
                    >
                      <div className="w-1/6">
                        <p>{`${it}:`}</p>
                      </div>
                      {items[it].map((option, i) => (
                        <div key={i} className="flex gap-4 ml-4">
                          <input
                            className="h-5 w-5"
                            type="radio"
                            value={option}
                            name={`select-${it}`}
                            onChange={(e) =>
                              handleCertification(e, it.toLowerCase())
                            }
                            checked={
                              userdata.certification[it.toLowerCase()] ===
                              option
                            }
                          />
                          <p>{option}</p>
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              ))}
              <div className="flex w-full flex-col md:flex-row text-left">
                <div className="w-1/6">
                  <p>Credential:</p>
                </div>
                <div className="flex gap-4 ml-4 md:w-5/6">
                  <textarea
                    value={
                      "https://bornaccessible.org/certification/gca-credential/"
                    }
                    onChange={handleCredentialsChange}
                    className="w-full border-[1px] border-commonborder rounded-[12px] min-h-[100px] max-h-[125px] outline-none p-4 overflow-auto"
                  ></textarea>
                  <p></p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex gap-5 ml-auto">
            <button
              onClick={(event) => {
                handleNext(event, fileId, stage.previous);
              }}
              className="w-fit mt-20 flex "
            >
              <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
                PREV
              </p>
            </button>
            <button className=" w-fit mt-auto flex justify-end">
              <p className="py-3 px-6 rounded-[12px] text-white bg-highlight text-14 font-bold">
                Submit
              </p>
            </button>
          </div>
        </form>
        {showModal && (
          <Modal
            title={"Alert"}
            body={
              "Do you wish to continue the processing in the Background and continue to Dashboard ?"
            }
            setShow={setShowModal}
            setConfirm={runInBg}
            setSecondary={runInloading}
            cancelbtn={"Cancel"}
            confirmbtn={"Run in Background"}
            secondarybtn={"Continue to Loading screen"}
            // setbackground={setRunInBackground}
          />
        )}
      </div>
    </LoadingScreen>
  );
};

export default Metadata;
